export default {
  inviteFriendReport: {
    total: "Tổng cộng",
    depth: { root: "Bạn bè cấp cao nhất", level: "Bạn bè cấp {{level}}" },
    scope: { root: "Toàn tuyến", inviter: "Bạn mời trực tiếp (1 cấp)", member: "Bản thân" },
    scopeDirect: "Dữ liệu trực thuộc",
    rowType: { context: "Bạn bè cấp cao nhất của tuyến (dòng tham chiếu)", hit: "Người dùng khớp" },
    filter: {
      account: "Tài khoản",
      tag: "Nhãn người dùng",
      tagPlaceholder: "VD: Chuyên viên quảng bá",
      currency: "Loại tiền",
      range: "Khoảng thời gian thống kê",
      agent: "Đại lý",
      agentAll: "Tất cả",
      agentUnassigned: "Chưa phân bổ"
    },
    column: {
      member: "Người dùng",
      scope: "Cấp / Phạm vi",
      agentAccount: "Đại lý",
      date: "Ngày",
      inviteMemberCount: "Số người được mời",
      directInviteCount: "Số mời trực tiếp",
      firstDepositMemberCount: "Số người nạp lần đầu",
      firstDepositAmount: "Số tiền nạp lần đầu",
      depositTimes: "Số lần nạp",
      depositAmount: "Số tiền nạp",
      withdrawTimes: "Số lần rút",
      withdrawAmount: "Số tiền rút",
      validBetAmount: "Cược hợp lệ",
      ggrAmount: "GGR",
      bonusAmount: "Ưu đãi đã nhận (gồm hoa hồng)",
      commissionAmount: "Trong đó: hoàn tiền mời bạn",
      pointExchangeCash: "Đổi điểm ra tiền mặt",
      directFriend: "Bạn mời trực tiếp",
      selfDepositAmount: "Số tiền nạp của bản thân",
      selfWithdrawAmount: "Số tiền rút của bản thân",
      selfValidBetAmount: "Cược hợp lệ của bản thân",
      selfGgrAmount: "GGR của bản thân",
      selfBonusAmount: "Ưu đãi đã nhận của bản thân (gồm hoàn tiền)",
      selfCommissionAmount: "Hoàn tiền mời bạn của bản thân",
      selfPointExchangeCash: "Đổi điểm của bản thân",
      trendInviteMember: "Người dùng được mời",
      trendFirstDepositMember: "Người được mời nạp lần đầu",
      action: "Thao tác"
    },
    action: { view: "Xem" },
    breadcrumb: { back: "Quay lại danh sách", list: "Danh sách tổng hợp" },
    composition: { rest: "Tổng cấp sâu hơn (từ cấp 2, không liệt kê từng người)", total: "Tổng cộng (= Toàn tuyến = Thẻ chỉ số)" },
    analysis: {
      title: "Phân tích mời bạn của {{account}}",
      directFriends: "Cơ cấu bạn mời trực tiếp (mỗi dòng = dữ liệu của chính người đó)",
      trendTitle: "Xu hướng theo ngày ({{scope}})",
      trendHint: "Hiển thị theo ngày; khoảng ngày theo «Khoảng thời gian thống kê» phía trên; dòng tổng = tổng của khoảng (muốn xem tổng tuần / tháng thì chọn khoảng là tuần / tháng đó).",
      inviterScopeHint: "Không bao gồm dữ liệu của chính người này"
    },
    tip: {
      needCurrencyAndRange: "Vui lòng chọn loại tiền và khoảng thời gian trước",
      searchMixed: "Đã khớp người dùng không phải cấp cao nhất: dòng trên là bạn bè cấp cao nhất của tuyến (toàn tuyến), dòng dưới là dữ liệu trực thuộc của người đó. Hai phạm vi không thể cộng dồn nên tổng cộng đã bị ẩn."
    }
  },

  comprehensiveReport: {
    title: "Bảng tổng hợp",
    profit: "Lợi nhuận",
    profitRate: "Tỷ lệ lợi nhuận",
    totalBet: "Tổng cược",
    validBet: "Cược hợp lệ",
    betUsers: "Người đặt cược",
    onlineUsers: "Người dùng trực tuyến",
    onlineUsersTooltip: "Người dùng trực tuyến theo thời gian thực, không bị ảnh hưởng bởi bộ lọc",
    gameProfitLoss: "Lợi nhuận/Thua lỗ trò chơi",
    memberBalance: "Số dư thành viên",
    deposit: "Nạp tiền",
    totalDeposit: "Tổng nạp tiền",
    withdrawal: "Rút tiền",
    totalWithdrawal: "Tổng rút tiền",
    userStatistics: "Thống kê người dùng",
    bettingStatistics: "Thống kê cược",
    bettingOrders: "Đơn cược",
    monthlyComparison: "So sánh theo tháng",
    thisMonthProfit: "Lợi nhuận tháng này",
    thisMonthProfitRate: "Tỷ lệ lợi nhuận tháng này",
    lastMonthProfit: "Lợi nhuận tháng trước",
    lastMonthProfitRate: "Tỷ lệ lợi nhuận tháng trước",
    registeredUsers: "Người dùng đăng ký",
    firstDepositUsers: "Người dùng nạp tiền lần đầu",
    secondDepositUsers: "Người dùng nạp tiền lần hai",
    thirdDepositUsers: "Người dùng nạp tiền lần ba",
    memberCount: "Số lượng thành viên",
    users: "Người dùng",
    depositTransactions: "Giao dịch nạp tiền",
    withdrawalTransactions: "Giao dịch rút tiền",
    manualWithdrawal: "Rút tiền thủ công",
    countedWithdrawal: "Rút tiền được tính",
    uncountedWithdrawal: "Rút tiền không được tính",
    rejectedWithdrawal: "Tiền bị từ chối",
    totalPromo: "Tổng khuyến mãi",
    paymentMethods: {
      bankCard: "Thẻ ngân hàng",
      gcash: "Gcash",
      paymaya: "PAYmaya",
      manualDeposit: "Nạp tiền thủ công",
      countedDeposit: "Nạp tiền được tính",
      uncountedDeposit: "Nạp tiền không được tính",
      promo1: "Thưởng khuyến mãi",
      promo2: "Thưởng VIP",
      promo3: "Khuyến mãi 3"
    },
    withdrawalMethods: {
      bankCard: "Thẻ ngân hàng",
      gcash: "Gcash",
      paymaya: "PAYmaya"
    },
    vipWeeklySalary: "Lương tuần VIP",
    vipMonthlySalary: "Lương tháng VIP",
    vipBirthdayBonus: "Thưởng sinh nhật VIP",
    vipUpgradePoints: "Điểm nâng cấp VIP",
    vipRetentionPoints: "Điểm duy trì VIP",
    vipAppDailyPoints: "Điểm hằng ngày VIP app",
    vipH5DailyPoints: "Điểm hằng ngày VIP h5",
    vipUpgradeBonus: "Thưởng nâng cấp VIP",
    vipRetentionBonus: "Thưởng duy trì VIP",
    actManualBonus: "Thưởng khuyến mãi thủ công",
    actRealtimeRebateBonus: "Thưởng hoàn trả game VIP",
    actRegisterBonus: "Ưu đãi đăng ký",
    actRebateBonus: "Thưởng hoàn trả",
    Manual: "Manual",
    Bank: "Bank",
    detail: "Chi tiết",
    amount: "Số tiền",
    search: "Tìm kiếm",
    reset: "Đặt lại",
    today: "Hôm nay",
    yesterday: "Hôm qua",
    startDate: "Ngày bắt đầu",
    endDate: "Ngày kết thúc",
    registerCount: "Số người đăng ký",
    depositCount: "Số người nạp tiền",
    withdrawCount: "Số người rút tiền",
    betCount: "Số người đặt cược",
    firstDepositCount: "Số người nạp lần đầu",
    chart: "Biểu đồ",
    table: "Bảng",
    noData: "Không có dữ liệu",
    day: "Ngày",
    dataTip: "Lưu ý: (Dữ liệu thống kê trong ngày có thể bị trễ một giờ. Đối với các ngày khác, dữ liệu được chụp lại vào 23:59:59 hàng ngày)",
    dateRangeExceeded: "Khoảng thời gian tùy chỉnh không thể vượt quá 31 ngày",
    pointExchange: "Đổi Điểm",
    cashExchange: "Đổi Tiền Mặt",
    physicalExchange: "Đổi Hàng Thực",
    toolExchange: "Đổi Đạo Cụ",
    exchangeMemberCount: "Số Người",
    exchangeQuantity: "Số Lượng",
    exchangeAmount: "Số Tiền",
    exchangeTotal: "Tổng Cộng",
    adjustIncrease: "Hạn Mức Điều Chỉnh: Tăng",
    adjustDecrease: "Hạn Mức Điều Chỉnh: Giảm",
    backendToAgentAdjust: "Tài Khoản Backend Điều Chỉnh Cho Đại Lý",
    agentAdjust: "Đại Lý Điều Chỉnh",
    adjustTransactions: "Số Giao Dịch Phân Bổ"
  },
  regionChoropleth: {
    panelTitle: "Phân Bố Khu Vực ({country})",
    panelHint: "Nhấp vào khu vực để định vị trên bản đồ",
    legendTitle: "Chú Giải (Số Người)",
    countries: {
      PH: "Khu Vực Philippines",
      VN: "Khu Vực Việt Nam",
    },
  },
  activeUserDistribution: {
    title: "Bảng điều khiển người dùng hoạt động",
    filters: {
      timeRange: "Phạm vi thời gian",
      timeRangeRequired: "Vui lòng chọn phạm vi thời gian",
      currency: "Loại tiền",
      currencyRequired: "Vui lòng chọn loại tiền",
      currencyPlaceholder: "Chọn loại tiền",
      countryAll: "Tất cả",
    },
    actions: {
      search: "Tìm kiếm",
      reset: "Đặt lại",
    },
    cards: {
      dailyTrend: "Xu hướng người dùng hoạt động",
      agentDistribution: "Phân bố đại lý người dùng hoạt động",
      deviceDistribution: "Phân bố thiết bị người dùng hoạt động",
      mobileProviderDistribution: "Phân bố nhà mạng người dùng hoạt động",
      depositDistribution: "Phân bố nạp tiền người dùng hoạt động",
      regionDistribution: "Phân bố khu vực",
    },
    regionTable: {
      country: "Quốc gia",
      province: "Tỉnh/Thành",
      city: "Thành phố",
      total: "Số người",
    },
    labels: {
      activeUserCount: "Số người dùng hoạt động",
      noData: "Không có dữ liệu",
      noRegionData: "Không có dữ liệu khu vực",
      noCityData: "Không có dữ liệu thành phố",
      total: "Tổng người dùng hoạt động",
      unknown: "Không xác định",
      agentUnknown: "Loại đại lý {id}",
    },
    agentTypes: {
      official: "Trang web chính thức",
      agent: "Đại lý",
      adEntry: "Lối vào quảng cáo",
      activity: "Hoạt động",
    },
    devices: {
      all: "Tất cả",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "Khác",
    },
    mobileProviders: {
      smart: "Smart",
      globe: "Globe",
      dito: "DITO",
    },
    depositStatus: {
      firstDeposit: "Nạp lần đầu",
      repeatDeposit: "Nạp lại",
      noDeposit: "Chưa nạp",
    },
    regionMap: {
      title: "Phân bố khu vực (Bản đồ tỉnh PH)",
      provinceMapLabel: "Bản đồ tỉnh",
      columns: {
        region: "Khu vực",
        users: "Số người",
      },
      summary: {
        coverage: "{count} khu vực báo cáo",
      },
    },
  },
  userRegisterDistribution: {
    title: "Bảng điều khiển đăng ký người dùng",
    filters: {
      timeRange: "Thời gian đăng ký",
      timeRangeRequired: "Vui lòng chọn thời gian đăng ký",
      agentType: "Loại đại lý",
      agentTypePlaceholder: "Chọn loại đại lý",
      loginChannel: "Kênh đăng nhập",
      loginChannelPlaceholder: "Chọn kênh đăng nhập",
      currency: "Loại tiền",
      currencyPlaceholder: "Chọn loại tiền",
      countryAll: "Tất cả",
      mobileProvider: "Nhà mạng",
      mobileProviderPlaceholder: "Chọn nhà mạng",
      depositStatus: "Trạng thái nạp",
      depositStatusPlaceholder: "Chọn trạng thái nạp"
    },
    actions: {
      search: "Tìm kiếm",
      reset: "Đặt lại"
    },
    loginChannels: {
      all: "Tất cả",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "Khác"
    },
    depositStatus: {
      all: "Tất cả trạng thái",
      firstDeposit: "Người dùng nạp lần đầu",
      repeatDeposit: "Người dùng nạp lại",
      noDeposit: "Người dùng chưa nạp"
    },
    cards: {
      dailyTrend: "Xu hướng đăng ký",
      registerSource: "Phân bố nguồn đăng ký",
      loginChannel: "Phân bố kênh đăng nhập",
      depositStatus: "Phân bố trạng thái nạp",
      mobileProvider: "Phân bố nhà mạng",
      regionDistribution: "Phân bố khu vực"
    },
    regionTable: {
      country: "Quốc gia",
      province: "Tỉnh/Thành",
      city: "Thành phố",
      total: "Số người đăng ký"
    },
    labels: {
      registerCount: "Số đăng ký",
      noData: "Không có dữ liệu",
      noRegionData: "Không có dữ liệu khu vực",
      noCityData: "Không có dữ liệu thành phố",
      total: "Tổng đăng ký",
      unknown: "Không xác định",
      agentUnknown: "Loại đại lý {id}"
    },
    agentFallback: "Loại đại lý không xác định",
    fetchAgentFailed: "Không thể lấy danh sách loại đại lý",
    regionMap: {
      title: "Bản đồ nhiệt khu vực",
      countryPlaceholder: "Chọn quốc gia",
      noData: "Không có dữ liệu bản đồ",
      notSupported: "Chưa hỗ trợ bản đồ cho quốc gia này",
      loadFailed: "Tải bản đồ thất bại",
      loadFailedWithFallback: "Không thể tự tải bản đồ. Vui lòng đặt tệp GeoJSON tại {fallback} hoặc cấu hình một máy chủ dự phòng.",
      accessDenied: "Yêu cầu dữ liệu bản đồ bị từ chối, vui lòng dùng proxy máy chủ hoặc nguồn dữ liệu khác",
      tooltipRegion: "Khu vực",
      provinceMapLabel: "Bản đồ tỉnh",
      columns: {
        region: "Khu vực",
        users: "Số người"
      },
      summary: {
        title: "Tổng quan điểm nóng",
        total: "Tổng đăng ký",
        average: "Trung bình / tỉnh",
        peak: "Khu vực nóng nhất",
        low: "Khu vực lạnh nhất",
        topRegions: "Khu vực nổi bật",
        coverage: "{count} tỉnh có dữ liệu"
      }
    }
  },
  betRecordReportList: {
    title: "Truy vấn lịch sử cược",
    prompt: "(Ngoài bộ lọc thời gian, điền ít nhất một điều kiện tìm kiếm)",
    memberAccount: "Tài khoản thành viên",
    orderNumber: "Số đơn hàng",
    betNumber: "Số cược",
    betDetails: "Chi tiết cược",
    payoutAmount: "Số tiền trả thưởng",
    profitLossChange: "Thay đổi lãi/lỗ",
    betSlipStatus: "Trạng thái phiếu cược",
    settlementVersion: "Phiên bản thanh toán",
    repeatSettlement: "Thanh toán lặp lại",
    transferBetSlip: "Chuyển phiếu cược",
    gameName: "Tên trò chơi",
    gameCode: "Mã trò chơi",
    actions: "Thao tác",
    details: "Chi tiết",
    matchStartTime: "Thời gian bắt đầu trận đấu",
    isLive: "Có phải cược trực tiếp",
    leagueName: "Tên giải đấu",
    betMarket: "Thị trường cược",
    betOdds: "Tỷ lệ cược",
    parlayType: "Loại cược xiên",
    settled: "Đã thanh toán",
    unsettled: "Chưa thanh toán",
    yes: "Có",
    no: "Không",
    gameType: "Loại trò chơi",
    betTime: "Thời gian cược",
    settlementTime: "Thời gian thanh toán",
    settlementTimeFilter: "Lọc thời gian thanh toán",
    detailTitle: "Chi tiết phiếu cược thể thao",
    basicInfo: "Thông tin cơ bản",
    betContent: "Nội dung cược",
    settlementHistory: "Lịch sử thanh toán",
    betSlipNumber: "Số phiếu cược",
    firstSettlementTime: "Thời gian thanh toán đầu tiên",
    lastSettlementTime: "Thời gian thanh toán cuối cùng",
    memberProfitLoss: "Lãi/lỗ thành viên",
    jackpotContribution: "Số tiền đóng góp Jackpot",
    jackpotPayout: "Số tiền trả thưởng Jackpot",
    eventName: "Tên sự kiện",
    finalScore: "Tỷ số cuối cùng",
    singleItemStatus: "Trạng thái mục đơn",
    settlementStatus: "Trạng thái thanh toán",
    settlementCurrency: "Tiền tệ thanh toán",
    profitLossAmount: "Số tiền lãi/lỗ",
    settlementReason: "Lý do thanh toán",
    win: "Thắng",
    lose: "Thua",
    halfWin: "Thắng nửa",
    halfLose: "Thua nửa",
    push: "Hòa",
    cancelled: "Đã hủy",
    pendingSettlement: "Chờ thanh toán",
    sportBetDetails: "Chi tiết phiếu cược thể thao",
    timeFilter: "Bộ lọc thời gian",
    dateRangeExceed32Days: "Phạm vi ngày không được vượt quá 32 ngày",
    settleDateRangeExceed32Days: "Phạm vi ngày thanh toán không được vượt quá 32 ngày",
    selectBetTime: "Vui lòng chọn thời gian đặt cược",
    loadDataFailed: "Tải dữ liệu thất bại",
    collapse: "Thu gọn",
    expand: "Mở rộng",
    parlayCount: "Parlay {count}"
  },
"betRecordHourlyList": {
    "title": "Báo Cáo Lịch Sử Cược",
    "prompt": "Dữ liệu ngày hôm trước được xử lý vào lúc 4 giờ sáng",
    "timeRange": "Khoảng Thời Gian",
    "timeRangeRequired": "Vui lòng chọn khoảng thời gian",
    "memberAccount": "Tài Khoản Thành Viên",
    "exportWarning": "Vui lòng nhập điều kiện tìm kiếm trước",
    "notes": "Ghi chú:",
    "note1": "Dữ liệu ngày hôm trước được xử lý vào lúc 4 giờ sáng",
    "note2": "Không thể truy vấn dữ liệu cược của ngày hiện tại",
    "note3": "Hỗ trợ xem dữ liệu theo trang, người dùng có thể chọn số lượng hiển thị mỗi trang"
},


  gamePlatformReport: {
    date: "Ngày tháng",
    statisticsDate: "Ngày thống kê",
    platformType: "Loại nền",
    platformName: "Tên nền",
    platformKey: "Mã nền",
    currency: "Loại tiền",
    betUsers: "Số người đặt cược",
    betOrders: "Số đơn cược",
    betAmount: "Số tiền cược",
    memberProfit: "Lợi nhuận thành viên",
    platformProfit: "Lợi nhuận nền",
    killRate: "Tỷ lệ giết",
    killRateTooltip: "Lợi nhuận nền / Số tiền cược",
    rtp: "RTP",
    rtpTooltip: "1 - Tỷ lệ giết",
    ggr: "GGR",
    ggrTooltip: "Số tiền cược - Tiền thưởng",
    total: "Tổng cộng",
    subGameName: "Tên trò chơi con",
    enterPlatformName: "Nhập tên nền",
    enterPlatformKey: "Nhập mã nền",
    enterSubGameName: "Nhập tên trò chơi con",
    all: "Tất cả",
    today: "Hôm nay",
    yesterday: "Hôm qua",
    thisWeek: "Tuần này",
    thisMonth: "Tháng này",
    lastMonth: "Tháng trước",
    last7Days: "7 ngày qua",
    last30Days: "30 ngày qua",
    totalRecords: "Tổng cộng {total} bản ghi",
    search: "Tìm kiếm",
    reset: "Đặt lại",
    noData: "Không có dữ liệu",
  },
  gameCodeReport: {
    title: "Báo cáo trò chơi con",
    prompt: "Dữ liệu ngày hôm trước được xử lý vào lúc 4 giờ sáng",
    memberAccount: "Tài khoản thành viên",
    orderNumber: "Số đơn hàng",
    statisticsDate: "Ngày thống kê",
    gameName: "Tên trò chơi",
    platformName: "Tên nền",
    platformKey: "Mã nền",
    currency: "Loại tiền",
    betUsers: "Số người đặt cược",
    betOrders: "Số đơn cược",
    betAmount: "Số tiền cược",
    memberProfit: "Lợi nhuận thành viên",
    platformProfit: "Lợi nhuận nền",
    killRate: "Tỷ lệ giết",
    killRateTooltip: "Lợi nhuận nền / Số tiền cược",
    rtp: "RTP",
    rtpTooltip: "1 - Tỷ lệ giết",
    ggr: "GGR",
    ggrTooltip: "Số tiền cược - Tiền thưởng",
    total: "Tổng cộng",
    enterGameName: "Nhập tên trò chơi",
    enterPlatformName: "Nhập tên nền",
    enterPlatformKey: "Nhập mã nền",
    enterSubGameName: "Nhập tên trò chơi con",
    all: "Tất cả",
    today: "Hôm nay",
    yesterday: "Hôm qua",
    thisWeek: "Tuần này",
    thisMonth: "Tháng này",
    lastMonth: "Tháng trước",
    last7Days: "7 ngày qua",
    last30Days: "30 ngày qua",
    totalRecords: "Tổng cộng {total} bản ghi",
    search: "Tìm kiếm",
    reset: "Đặt lại",
    noData: "Không có dữ liệu",
  },
  depositReport: {
    title: "Báo cáo nạp tiền",
    date: "Ngày nạp tiền",
    currency: "Loại tiền",
    paymentChannel: "Kênh nạp tiền",
    totalOrders: "Tổng số đơn nạp",
    totalAmount: "Tổng số tiền nạp",
    totalSuccessOrders: "Tổng số đơn nạp thành công",
    totalPaySuccessAmount: "Tổng số tiền nạp thành công",
    successRate: "Tỷ lệ thành công",
    thirdPartySuccessRate: "Tỷ lệ thành công của bên thứ ba",
    depositDate: "Ngày nạp tiền",
    selectPaymentChannel: "Vui lòng chọn kênh nạp tiền",
    total: "Tổng cộng",
    search: "Tìm kiếm",
    reset: "Đặt lại",
    all: "Tất cả",
    totalRecords: "Tổng cộng {total} bản ghi",
    noData: "Không có dữ liệu",
    dateRange: {
      today: "Hôm nay",
      yesterday: "Hôm qua",
      thisWeek: "Tuần này",
      thisMonth: "Tháng này",
      lastMonth: "Tháng trước",
      last7Days: "7 ngày qua",
      last30Days: "30 ngày qua"
    }
  },
  agentBonusStats: {
    title: "Báo Cáo Ưu Đãi Đại Lý",
    dateRange: "Khoảng Thời Gian",
    dateRangeRequired: "Vui lòng chọn khoảng thời gian",
    dateRangeExceeds3Months: "Khoảng thời gian không được vượt quá 3 tháng",
    cannotQueryCurrentDay: "Không thể truy vấn dữ liệu ngày hiện tại",
    agentAccount: "Tài khoản đại lý",
    agentAccountPlaceholder: "Nhập tài khoản đại lý",
    currency: "Tiền tệ",
    currencyPlaceholder: "Chọn tiền tệ",
    bonusName: "Tên ưu đãi",
    bonusNamePlaceholder: "Nhập tên ưu đãi",
    bonusType: "Loại ưu đãi",
    bonusTypePlaceholder: "Chọn loại ưu đãi",
    joinCount: "Số người tham gia",
    bonusAmount: "Số tiền phân phối",
    bonusPoint: "Điểm phân phối",
    day: "Ngày thống kê",
    cashTab: "Tiền mặt",
    pointsTab: "Điểm",
    agentName: "Tên đại lý",
    agentType: "Loại đại lý",
    level1Agent: "Cấp 1",
    directAgent: "Trực thuộc",
    level2Agent: "Cấp 2",
    summary: "Tổng hợp"
  },
  bonusRecordReport: {
    title: "Báo Cáo Khuyến Mãi",
    prompt: "Truy vấn dữ liệu phân phối khuyến mãi",
    dateRange: "Khoảng Thời Gian",
    dateRangeRequired: "Vui lòng chọn khoảng thời gian",
    dateRangeExceedsLimit: "Khoảng thời gian không được vượt quá 7 ngày",
    dateRangeExceeds3Months: "Khoảng thời gian không được vượt quá 3 tháng",
    dateRangeExceeds6Months: "Khoảng thời gian không được vượt quá 6 tháng",
    cannotQueryCurrentDay: "Không thể truy vấn dữ liệu của ngày hiện tại",
    pleaseEnterMemberAccount: "Vui lòng nhập tài khoản thành viên",
    pleaseEnterSearchCriteria: "Vui lòng nhập ít nhất một tiêu chí tìm kiếm",
    currency: "Loại Tiền",
    currencyPlaceholder: "Chọn loại tiền",
    bonusName: "Tên Khuyến Mãi",
    bonusNamePlaceholder: "Nhập tên khuyến mãi",
    bonusType: "Loại Khuyến Mãi",
    bonusTypePlaceholder: "Chọn loại khuyến mãi",
    "bonusType.monthlySalaryPoint": "Điểm Lương Tháng",
    "bonusType.weeklySalaryPoint": "Điểm Lương Tuần",
    "bonusType.birthdayPoint": "Điểm Sinh Nhật",
    joinCount: "Số Người Tham Gia",
    bonusAmount: "Số Tiền Khuyến Mãi",
    bonusPoint: "Điểm Khuyến Mãi",
    day: "Ngày",
    cashTab: "Tiền Mặt",
    pointsTab: "Điểm",
    status: "Trạng Thái",
    completed: "Đã Hoàn Thành",
    pending: "Chưa Hoàn Thành",
    memberAccount: "Tài Khoản Thành Viên",
    memberAccountPlaceholder: "Nhập tài khoản thành viên"
  },
  withdrawReport: {
    title: "Báo Cáo Rút Tiền",
    withdrawDate: "Ngày Rút Tiền",
    currency: "Loại Tiền",
    withdrawChannel: "Kênh Rút Tiền",
    withdrawModel: "Phương thức rút tiền",
    serialNumber: "STT",
    totalWithdrawCount: "Tổng Số Lần Rút Tiền",
    totalWithdrawAmount: "Tổng Số Tiền Rút",
    withdrawFee: "Phí Rút Tiền",
    successfulWithdrawCount: "Số Lần Rút Tiền Thành Công",
    successfulWithdrawAmount: "Số Tiền Rút Thành Công",
    withdrawSuccessRate: "Tỷ Lệ Rút Tiền Thành Công",
    manual: "Thủ Công",
    all: "Tất Cả",
    total: "Tổng Cộng",
    search: "Tìm Kiếm",
    reset: "Đặt Lại",
    export: "Xuất",
    totalRecords: "Tổng cộng {total} bản ghi",
    dateRangeRequired: "Vui lòng chọn khoảng thời gian",
    exporting: "Đang xuất, vui lòng chờ...",
    exportSuccess: "Xuất thành công",
    exportFailed: "Xuất thất bại",
    today: "Hôm Nay",
    yesterday: "Hôm Qua",
    thisWeek: "Tuần Này",
    thisMonth: "Tháng Này",
    lastMonth: "Tháng Trước",
    last7Days: "7 Ngày Qua",
    last30Days: "30 Ngày Qua"
  },
  registrationConversionReport: {
    title: "Báo Cáo Đăng Ký Và Chuyển Đổi",
    dateRange: "Khoảng Thời Gian",
    date: "Ngày",
    day: "Ngày",
    registerCount: "Số Người Đăng Ký",
    registerFirstDepositCount: "Đăng Ký Nạp Tiền Lần Đầu",
    activeFirstDeposit: "Nạp Tiền Lần Đầu Hoạt Động",
    registerFirstDepositRate: "Tỷ Lệ Chuyển Đổi Nạp Tiền Lần Đầu",
    totalFirstDepositRate: "Tỷ Lệ Chuyển Đổi Nạp Tiền Lần Đầu Tổng",
    retentionCount: "Số Người Duy Trì",
    cumulativeDepositNumber: "Số Lần Nạp Tiền Tích Lũy",
    cumulativeDepositAmount: "Số Tiền Nạp Tích Lũy",
    search: "Truy Vấn",
    reset: "Đặt Lại",
    export: "Xuất",
    noData: "Không Có Dữ Liệu",
    isAppUser: "Vui lòng chọn có phải người dùng APP",
    selectAppUser: "Vui lòng chọn",
    yes: "Có",
    no: "Không",
    all: "Tất Cả",
    selectAgentType: "Chọn Loại Đại Lý",
    selectAgentTypePlaceholder: "Vui lòng chọn",
    firstLevelAgent: "Đại Lý Cấp 1",
    secondLevelAgent: "Đại Lý Cấp 2",
    agentAccount: "Vui lòng nhập tài khoản đại lý",
    enterAgentAccount: "Vui lòng nhập tài khoản đại lý",
    agentTag: "Nhãn Đại Lý",
    selectAgentTag: "Vui lòng chọn nhãn đại lý",
    query: "Truy Vấn",
    report: "Báo Cáo",
    chart: "Biểu Đồ",
    conversionRateChart: "Biểu Đồ Tỷ Lệ Chuyển Đổi Nạp Tiền Lần Đầu",
    depositAmountChart: "Biểu Đồ Số Tiền Nạp Tích Lũy",
    noDataForChart: "Không có dữ liệu biểu đồ",
    selectTime: "Chọn Thời Gian",
    queryFailed: "Truy Vấn Thất Bại",
    exportSuccess: "Xuất Thành Công",
    exportFailed: "Xuất Thất Bại",
    items: "mục",
    userStatistics: "Thống Kê Đăng Ký Và Chuyển Đổi",
    table: "Bảng",
    dataTip: "Mẹo Dữ Liệu",
    firstDepositCount: "Nạp Tiền Lần Đầu Hoạt Động",
    firstDepositRate: "Tỷ Lệ Chuyển Đổi Nạp Tiền Lần Đầu Tổng",
    coiledDepositCount: "Số Người Duy Trì",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức",
  },
  valueStatsReport: {
    title: "Báo Cáo Thống Kê Giá Trị",
    dateRange: "Khoảng Thời Gian",
    date: "Ngày",
    registerCount: "Số Người Đăng Ký",
    depositCount: "Số Người Nạp Tiền",
    depositAmount: "Số Tiền Nạp",
    withdrawAmount: "Số Tiền Rút",
    firstDayLtv: "LTV Ngày Đầu",
    thirdDayLtv: "LTV 3 Ngày",
    seventhDayLtv: "LTV 7 Ngày",
    fifteenthDayLtv: "LTV 15 Ngày",
    thirtiethDayLtv: "LTV 30 Ngày",
    fortyFifthDayLtv: "LTV 45 Ngày",
    sixtiethDayLtv: "LTV 60 Ngày",
    seventyFifthDayLtv: "LTV 75 Ngày",
    ninetiethDayLtv: "LTV 90 Ngày",
    oneHundredFifthDayLtv: "LTV 105 Ngày",
    oneHundredTwentiethDayLtv: "LTV 120 Ngày",
    oneHundredThirtyFifthDayLtv: "LTV 135 Ngày",
    oneHundredFiftiethDayLtv: "LTV 150 Ngày",
    dailyArppu: "ARPPU Hàng Ngày",
    search: "Truy Vấn",
    reset: "Đặt Lại",
    export: "Xuất",
    noData: "Không Có Dữ Liệu",
    isAppUser: "Vui lòng chọn người dùng APP",
    selectAppUser: "Vui lòng chọn",
    yes: "Có",
    no: "Không",
    all: "Tất Cả",
    selectAgentType: "Chọn Loại Đại Lý",
    selectAgentTypePlaceholder: "Vui lòng chọn",
    firstLevelAgent: "Đại Lý Cấp 1",
    secondLevelAgent: "Đại Lý Cấp 2",
    agentAccount: "Vui lòng nhập tài khoản đại lý",
    enterAgentAccount: "Vui lòng nhập tài khoản đại lý",
    agentTag: "Nhãn Đại Lý",
    selectAgentTag: "Vui lòng chọn nhãn đại lý",
    query: "Truy Vấn",
    report: "Báo Cáo",
    chart: "Biểu Đồ",
    selectTime: "Chọn Thời Gian",
    queryFailed: "Truy Vấn Thất Bại",
    exportSuccess: "Xuất Thành Công",
    exportFailed: "Xuất Thất Bại",
    selectCurrency: "Vui lòng chọn tiền tệ",
    items: "mục",
    chartComingSoon: "Tính năng biểu đồ sắp ra mắt",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức"
  },
  keepStatsReport: {
    title: "Báo Cáo Giữ Chân Nạp Tiền",
    dateRange: "Khoảng Thời Gian",
    date: "Ngày",
    day: "Ngày",
    registerCount: "Số Người Đăng Ký",
    firstDepositCount: "Số Người Đăng Ký Nạp Lần Đầu",
    firstDepositRate: "Tỷ Lệ Đăng Ký Nạp Lần Đầu",
    registerFirstDepositCount: "Số Người Nạp Lần Đầu Đăng Ký",
    totalFirstDepositRate: "Tỷ Lệ Nạp Lần Đầu Tổng",
    activeFirstDepositCount: "Số Người Nạp Lần Đầu Hoạt Động",
    activeFirstDepositRate: "Tỷ Lệ Nạp Lần Đầu Hoạt Động",
    coiledDepositCount: "Số Người Nạp Lại Hàng Ngày",
    coiledDepositRate: "Tỷ Lệ Nạp Lại Trong Ngày",
    firstDayRetention: "Giữ Chân Ngày 1",
    firstDayRetentionTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 1",
    tomorrowKept: "Giữ Chân Ngày 2",
    tomorrowKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 2",
    tomorrowKeptRate: "Tỷ Lệ Giữ Chân Ngày Hôm Sau",
    threeKept: "Giữ Chân Ngày 3",
    threeKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 3",
    threeKeptRate: "Tỷ Lệ Giữ Chân 3 Ngày",
    fourKept: "Giữ Chân Ngày 4",
    fourKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 4",
    fourKeptRate: "Tỷ Lệ Giữ Chân 4 Ngày",
    fiveKept: "Giữ Chân Ngày 5",
    fiveKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 5",
    fiveKeptRate: "Tỷ Lệ Giữ Chân 5 Ngày",
    sixKept: "Giữ Chân Ngày 6",
    sixKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 6",
    sixKeptRate: "Tỷ Lệ Giữ Chân 6 Ngày",
    sevenKept: "Giữ Chân Ngày 7",
    sevenKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 7",
    sevenKeptRate: "Tỷ Lệ Giữ Chân 7 Ngày",
    fifteenKept: "Giữ Chân Ngày 15",
    fifteenKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 15",
    fifteenKeptRate: "Tỷ Lệ Giữ Chân 15 Ngày",
    thirtyKept: "Giữ Chân Ngày 30",
    thirtyKeptTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Nạp Tiền Ngày 30",
    thirtyKeptRate: "Tỷ Lệ Giữ Chân 30 Ngày",
    thirtyCoiledDepositCount: "Số Người Nạp Lại 30 Ngày",
    thirtyCoiledDepositRate: "Tỷ Lệ Nạp Lại 30 Ngày",
    dailyCoiledDepositRate: "Tỷ Lệ Nạp Lại Hàng Ngày",
    thirtyCoiledDepositDetail: "Chi Tiết Nạp Lại 30 Ngày",
    search: "Truy Vấn",
    reset: "Đặt Lại",
    export: "Xuất",
    noData: "Không Có Dữ Liệu",
    isAppUser: "Vui lòng chọn người dùng APP",
    selectAppUser: "Vui lòng chọn",
    yes: "Có",
    no: "Không",
    all: "Tất Cả",
    selectAgentType: "Chọn Loại Đại Lý",
    selectAgentTypePlaceholder: "Vui lòng chọn",
    firstLevelAgent: "Đại Lý Cấp 1",
    secondLevelAgent: "Đại Lý Cấp 2",
    agentAccount: "Vui lòng nhập tài khoản đại lý",
    enterAgentAccount: "Vui lòng nhập tài khoản đại lý",
    agentTag: "Nhãn Đại Lý",
    selectAgentTag: "Vui lòng chọn nhãn đại lý",
    query: "Truy Vấn",
    selectTime: "Chọn Thời Gian",
    queryFailed: "Truy Vấn Thất Bại",
    exportSuccess: "Xuất Thành Công",
    exportFailed: "Xuất Thất Bại",
    selectCurrency: "Vui lòng chọn tiền tệ",
    items: "mục",
    report: "Báo Cáo",
    chart: "Biểu Đồ",
    retentionChart: "Biểu Đồ Dữ Liệu Giữ Chân",
    noDataForChart: "Không có dữ liệu biểu đồ",
    retentionCount: "Số Lượng Giữ Chân",
    userStatistics: "Thống Kê Dữ Liệu Giữ Chân",
    table: "Bảng",
    dataTip: "Mẹo Dữ Liệu",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức"
  },
  betKeepStatsReport: {
    title: "Báo Cáo Giữ Chân Đặt Cược",
    dateRange: "Khoảng Thời Gian",
    day: "Ngày",
    registerCount: "Số Người Đăng Ký",
    firstBetCount: "Số Người Đặt Cược Lần Đầu Đăng Ký",
    firstBetRate: "Tỷ Lệ Đặt Cược Lần Đầu Đăng Ký",
    delayFirstBetCount: "Số Người Đặt Cược Lần Đầu Hoạt Động",
    totalFirstBetRate: "Tỷ Lệ Đặt Cược Lần Đầu Tổng",
    activeFirstBetRate: "Tỷ Lệ Đặt Cược Lần Đầu Hoạt Động",
    thirtyRebetCount: "Số Người Đặt Cược Lại 30 Ngày",
    thirtyRebetCountTooltip: "Người dùng đặt cược lần đầu và đặt cược lại trong vòng 30 ngày",
    thirtyRebetRate: "Tỷ Lệ Đặt Cược Lại 30 Ngày",
    thirtyRebetRateTooltip: "Số Người Đặt Cược Lại 30 Ngày / Số Người Đặt Cược Lần Đầu Đăng Ký",
    firstDayBet: "Đặt Cược Lại Ngày 1",
    firstDayBetTooltip: "Người dùng đặt cược lần đầu D0 đặt cược lại trong cùng ngày",
    tomorrowBet: "Đặt Cược Ngày 2",
    tomorrowBetTooltip: "Người dùng đặt cược lần đầu đặt cược ngày hôm sau (D1)",
    threeBet: "Đặt Cược Ngày 3",
    threeBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 3 (D2)",
    fourBet: "Đặt Cược Ngày 4",
    fourBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 4 (D3)",
    fiveBet: "Đặt Cược Ngày 5",
    fiveBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 5 (D4)",
    sixBet: "Đặt Cược Ngày 6",
    sixBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 6 (D5)",
    sevenBet: "Đặt Cược Ngày 7",
    sevenBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 7 (D6)",
    fifteenBet: "Đặt Cược Ngày 15",
    fifteenBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 15 (D14)",
    thirtyBet: "Đặt Cược Ngày 30",
    thirtyBetTooltip: "Số Lượng/Tỷ Lệ Giữ Chân Đặt Cược Ngày 30 (D29)",
    isAppUser: "Vui lòng chọn người dùng APP",
    selectAppUser: "Vui lòng chọn",
    yes: "Có",
    no: "Không",
    all: "Tất Cả",
    selectAgentType: "Chọn Loại Đại Lý",
    selectAgentTypePlaceholder: "Vui lòng chọn",
    agentAccount: "Tài Khoản Đại Lý",
    enterAgentAccount: "Vui lòng nhập tài khoản đại lý",
    agentTag: "Nhãn Đại Lý",
    selectAgentTag: "Vui lòng chọn nhãn đại lý",
    query: "Truy Vấn",
    export: "Xuất",
    reset: "Đặt Lại",
    noData: "Không Có Dữ Liệu",
    userStatistics: "Thống Kê Giữ Chân Đặt Cược",
    table: "Bảng",
    dateRangeExceeded: "Khoảng thời gian không được vượt quá 31 ngày",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức",
    thirtyRebetDetail: "Chi Tiết Đặt Cược Lại 30 Ngày"
  },
  delayFirstDeposit: {
    title: "Lịch Sử Nạp Lần Đầu Trễ",
    description: "Ngày Đăng Ký",
    memberAccount: "Tài Khoản Thành Viên",
    registerTime: "Thời Gian Đăng Ký",
    firstDepositTime: "Thời Gian Nạp Lần Đầu",
    firstDepositAmount: "Số Tiền Nạp Lần Đầu",
    agentAccount: "Tài Khoản Đại Lý",
  },
  overviewStatsReport: {
    title: "Báo Cáo Tổng Quan",
    summary: "Thống Kê Tổng Quan",
    dateRange: "Khoảng Thời Gian",
    date: "Ngày",
    day: "Ngày",
    loginCount: "Số Lượng Đăng Nhập",
    registerCount: "Số Lượng Đăng Ký",
    memberLoginCount: "Số Lượng Đăng Nhập",
    firstDepositCount: "Số Lượng Nạp Lần Đầu",
    firstDepositRate: "Tỷ Lệ Nạp Lần Đầu",
    depositAmount: "Tổng Số Tiền Nạp",
    withdrawAmount: "Tổng Số Tiền Rút",
    profitAndLoss: "Lãi/Lỗ Nạp Rút",
    registerFirstDepositCount: "Nạp Lần Đầu Đăng Ký",
    activeFirstDepositCount: "Nạp Lần Đầu Hoạt Động",
    registerFirstDepositRate: "Tỷ Lệ Nạp Lần Đầu Đăng Ký",
    totalFirstDepositRate: "Tỷ Lệ Nạp Lần Đầu Tổng",
    tomorrowRetention: "Giữ Chân Ngày Hôm Sau",
    sevenDayRetention: "Giữ Chân 7 Ngày",
    thirtyDayRetention: "Giữ Chân 30 Ngày",
    firstDayLTV: "LTV (Ngày Đầu)",
    thirtyDayLTV: "LTV (30 Ngày)",
    search: "Tìm Kiếm",
    reset: "Đặt Lại",
    report: "Báo Cáo",
    chart: "Biểu Đồ",
    overviewChart: "Biểu Đồ Dữ Liệu Tổng Quan",
    noDataForChart: "Không có dữ liệu biểu đồ",
    queryFailed: "Truy Vấn Thất Bại",
    noData: "Không Có Dữ Liệu",
    items: "mục",
    export: "Xuất",
    exportSuccess: "Xuất Thành Công",
    exportFailed: "Xuất Thất Bại",
    isAppUser: "Vui lòng chọn có phải người dùng APP",
    selectAppUser: "Vui lòng chọn",
    yes: "Có",
    no: "Không",
    all: "Tất Cả",
    selectAgentType: "Chọn Loại Đại Lý",
    selectAgentTypePlaceholder: "Vui lòng chọn",
    firstLevelAgent: "Đại Lý Cấp 1",
    secondLevelAgent: "Đại Lý Cấp 2",
    agentAccount: "Vui lòng nhập tài khoản đại lý",
    enterAgentAccount: "Vui lòng nhập tài khoản đại lý",
    agentTag: "Nhãn Đại Lý",
    selectAgentTag: "Vui lòng chọn nhãn đại lý",
    query: "Truy Vấn",
    selectTime: "Chọn Thời Gian",
    selectCurrency: "Vui lòng chọn tiền tệ",
    userStatistics: "Thống Kê Dữ Liệu Tổng Quan",
    table: "Bảng",
    dataTip: "Mẹo Dữ Liệu",
    officialDirect: "Khách Hàng Trực Tiếp Chính Thức"
  },
  memberLoginLogReport: {
    title: "Báo Cáo Lịch Sử Đăng Nhập",
    dateRange: "Thời Gian Đăng Nhập",
    date: "Ngày",
    day: "Ngày",
    registerCount: "Số Lượng Đăng Ký",
    depositCount: "Số Lượng Nạp Tiền",
    loginIp: "IP Đăng Nhập",
    loginDeviceId: "ID thiết bị đăng nhập",
    ipLocation: "IP Thuộc Tính",
    loginMethod: "Phương Thức Đăng Nhập",
    loginChannel: "Kênh Đăng Nhập",
    memberAccount: "Tài Khoản Thành Viên",
    enterMemberAccount: "Vui lòng nhập tài khoản thành viên",
    enterLoginIp: "Vui lòng nhập IP đăng nhập",
    enterIpLocation: "Vui lòng nhập IP thuộc tính",
    enterLoginMethod: "Vui lòng nhập phương thức đăng nhập",
    enterLoginChannel: "Vui lòng nhập kênh đăng nhập",
    all: "Tất Cả",
    loginDomain: "Tên Miền Đăng Nhập",
    unknownLocation: "Không xác định",
    loginChannels: {
      all: "Tất Cả",
      others: "Khác",
      web: "Web",
      androidApp: "Android APP",
      androidH5: "Android H5",
      androidPwa: "Android PWA",
      iosH5: "iOS H5",
      iosPwa: "iOS PWA",
      iosApp: "IOS APP"
    },
    loginMethods: {
      all: "Tất Cả",
      password: "Tên đăng nhập/Mật khẩu",
      facebook: "Facebook",
      google: "Google",
      apple: "Apple"
    },
  },
  memberLoginLogSummary: {
    title: "Báo Cáo Tổng Quan Lịch Sử Đăng Nhập",
    dateRange: "Khoảng Thời Gian",
    date: "Ngày",
    day: "Ngày",
    registerCount: "Số Lượng Đăng Ký",
    depositCount: "Số Lượng Nạp Tiền",
  },
  onlineUserPanel: {
    title: "Bảng Điều Khiển Người Dùng Trực Tuyến",
    currentOnlineUsers: "Số Người Dùng Trực Tuyến Hiện Tại",
    currentOnlineUsersDesc: "Thống kê bao gồm: người dùng đã đăng nhập, vào trang game, vào trang nạp/rút tiền hoặc thực hiện hành động trong trung tâm cá nhân trong 30 phút qua",
    realtimeOnlineChart: "Người Dùng Trực Tuyến Theo Thời Gian Thực (So sánh ba ngày cùng thời điểm)",
    mobileProviderDistribution: "Phân Bố Nhà Mạng",
    deviceDistribution: "Phân Bố Thiết Bị",
    regionDistribution: "Phân Bố Khu Vực",
    regionList: "Phân Bố Khu Vực",
    onlineUserList: "Danh Sách Người Dùng Trực Tuyến",
    labels: {
      unknown: "Không Xác Định",
      noData: "Không Có Dữ Liệu",
      noCityData: "Không Có Dữ Liệu Thành Phố",
    },
    actionTypes: {
      login: "Đăng Nhập",
      logout: "Đăng Xuất",
      enterGame: "Vào Game",
      depositPage: "Trang Nạp Tiền",
      withdrawPage: "Trang Rút Tiền",
      personalCenter: "Trung Tâm Cá Nhân",
    },
    regionTable: {
      country: "Quốc Gia",
      province: "Tỉnh",
      city: "Thành Phố",
      total: "Số Người",
      all: "Tất Cả",
    },
    table: {
      memberAccount: "Tài Khoản Thành Viên",
      lastActionTime: "Thời Gian Hoạt Động Cuối",
      actionType: "Loại Hành Động",
      deviceType: "Loại Thiết Bị",
      totalRecords: "Hiện có {total} bản ghi",
    },
  },
  payOrderStat: {
    title: "Bảng Điều Khiển Nạp Tiền",
    selectCurrency: "Chọn Loại Tiền",
    orderOverview: "Tổng Quan Đơn Hàng",
    rechargeAmount: "Số Tiền Nạp",
    withdrawAmount: "Số Tiền Rút",
    payWithdrawDiff: "Chênh Lệch Nạp-Rút",
    statistics: "Thống Kê",
    totalPayCount: "Tổng Số Lần Nạp",
    successRate: "Tỷ Lệ Thành Công Nạp Tiền",
    avgPayTime: "Thời Gian Nạp Tiền Trung Bình",
    successCount: "Nạp Tiền Thành Công",
    failedCount: "Nạp Tiền Thất Bại",
    pendingCount: "Đang Xử Lý",
    channelTitle: "Phương Thức Nạp Tiền",
    selectChannel: "Chọn Phương Thức Nạp Tiền",
    channelTotalPayCount: "Tổng Số Lần Nạp",
    channelAvgPayTime: "Thời Gian Nạp Tiền Trung Bình",
    channelSuccessCount: "Nạp Tiền Thành Công",
    channelFailedCount: "Nạp Tiền Thất Bại",
    channelPendingCount: "Đang Xử Lý",
    fetchFailed: "Không thể lấy thống kê bảng điều khiển nạp tiền",
    channelFetchFailed: "Không thể lấy thống kê phương thức nạp tiền",
  },
  withdrawOrderStat: {
    title: "Bảng Điều Khiển Rút Tiền",
    selectCurrency: "Chọn Loại Tiền",
    orderOverview: "Tổng Quan Đơn Hàng",
    rechargeAmount: "Số Tiền Nạp",
    withdrawAmount: "Số Tiền Rút",
    payWithdrawDiff: "Chênh Lệch Nạp-Rút",
    statistics: "Thống Kê",
    totalWithdrawCount: "Tổng Số Lần Rút",
    successRate: "Tỷ Lệ Thành Công Rút Tiền",
    avgWithdrawTime: "Thời Gian Rút Tiền Trung Bình",
    avgRiskCheckTime: "Thời Gian Xem Xét Trung Bình",
    avgRiskCheckTimeTooltip: "Đơn Hàng Xem Xét Thủ Công",
    successCount: "Đã Chi Trả",
    refusedCount: "Đã Từ Chối",
    pendingPayoutCount: "Chờ Chi Trả",
    pendingReviewCount: "Chờ Xem Xét",
    pendingReviewCountTooltip: "Đơn Hàng Xem Xét Thủ Công",
    channelTitle: "Phương Thức Rút Tiền",
    selectChannel: "Chọn Phương Thức Rút Tiền",
    channelTotalWithdrawCount: "Tổng Số Lần Rút",
    channelAvgWithdrawTime: "Thời Gian Rút Tiền Trung Bình",
    channelAvgRiskCheckTime: "Thời Gian Xem Xét Trung Bình",
    channelSuccessCount: "Đã Chi Trả",
    channelRefusedCount: "Đã Từ Chối",
    channelPendingPayoutCount: "Chờ Chi Trả",
    channelPendingReviewCount: "Chờ Xem Xét",
    fetchFailed: "Không thể lấy thống kê bảng điều khiển rút tiền",
    channelFetchFailed: "Không thể lấy thống kê phương thức rút tiền",
  },
  crossDayTransferSettlement: {
    title: "Bảng Phân Tích Chuyển Kết Toán Liên Ngày",
    keyIndicators: "Chỉ Số Quan Trọng",
    selectDate: "Chọn Ngày Giờ",
    yesterdayUnsettledCount: "Số Lượng Cược Chưa Kết Toán Hôm Qua",
    todayCompletedTransferCount: "Số Lượng Chuyển Kết Toán Hoàn Thành Hôm Nay",
    todayRemainingUnsettledCount: "Số Lượng Cược Hôm Qua Vẫn Chưa Kết Toán Hôm Nay",
    todaySecondSettlementCount: "Số Lượng Cược Chuyển Kết Toán Lần Hai Hôm Nay",
    profitLossChange: "Thay Đổi Lợi Nhuận/Thua Lỗ (Kết Toán Lại)",
    repeatSettlementRatio: "Tỷ Lệ Kết Toán Lại",
  },
  jeepneyFunnelAnalysis: {
    title: "Phân Tích Phễu Jeepney",
    statisticsDate: "Ngày Thống Kê",
    dateSelect: "Chọn Ngày",
    fixedForToday: "Cố định cho ngày",
    dateRange: "Khoảng Thời Gian",
    funnelChart: "Biểu Đồ Phễu",
    funnelTable: "Bảng Phễu (Theo Chuỗi Sự Kiện)",
    metricCards: "Thẻ Chỉ Số",
    step: "Bước",
    event: "Sự Kiện",
    userCountUV: "Số Người (UV)",
    dimension: "Chiều",
    enterActivity: "Vào Trang Chính Hoạt Động",
    clickAdvance: "Nhấp Tiến Về (Ít nhất 1 lần)",
    insufficientCurrency: "Chặn Do Thiếu Tiền Tệ (Ít nhất 1 lần)",
    openCurrencyPopup: "Mở Popup Nhận Tiền Tệ (Ít nhất 1 lần)",
    completeCurrencyAcquire: "Hoàn Thành Nhận Tiền Tệ (Ít nhất 1 lần)",
    reachFinalStage: "Đạt Giai Đoạn Cuối",
    settlementSuccess: "Thanh Toán Thành Công",
    settlementFailure: "Thanh Toán Thất Bại",
    settlementResult: "Kết Quả Thanh Toán (Thành Công/Thất Bại)",
    activityParticipation: "Tham Gia Hoạt Động",
    rechargeUsers: "Người Nạp Tiền",
    exchangeUsers: "Người Đổi",
    inviteValidFriends: "Mời Bạn Bè Hợp Lệ",
    conversionRate: "Tỷ Lệ Chuyển Đổi",
    noData: "Không Có Dữ Liệu"
  }
};
